module.exports = __webpack_public_path__ + "static/Danilo Joksimovic.2832404d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Danilo Joksimovic.jpg
// module id = 1210
// module chunks = 6166952557895